<div class="img-container horizontal-battery">
  <img [src]="batteryStatus?.redBorder ? redBorderIconUrl : batteryStatus.contentIconUrl" alt="" />
</div>
